import { render, staticRenderFns } from "./PrintsTwoSettings.vue?vue&type=template&id=46870726&"
import script from "./PrintsTwoSettings.vue?vue&type=script&lang=js&"
export * from "./PrintsTwoSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports